<template>
	<div class="fplus-step-settings noscroll">
		<div class="layout-column noscroll">
			<div class="funnel_apps_header flex-none noscroll">
				<h3>Edit step</h3>
				<div class="right_btns">
					<v-button @click="closeSettings" border label="Cancel" />
					<v-button @click="saveStep" label="Save changes" :loading="saving"/>
				</div>
			</div>
			<loading v-if="loading" />
			<div v-else class=" scroll">
				<div class="funnel_apps_list">
					<div class="brdr_content_wrpr" v-if="newStep">
						<h3 class="brdr_content_title df">Step details
							<span class="check" v-if="newStep.type>0">
                  <span class="icon_check">
                      <inline-svg :src="stepTypes[newStep.type-1].img"/>
                  </span>
                  <span class="title">{{ stepTypes[newStep.type - 1].title }}</span>
              </span>
						</h3>

						<InputField label="Name" v-model="newStep.name" required></InputField>

						<InputField label="Step path" v-model="newStep.path"
						            @input="stripUrl($event, 'path')" :prepend="stepPath">
						</InputField>
						<div v-if="isGeoFunnel" class="alert_box blue" style="margin-top: -10px">
							<div class="icon">
								<inline-svg :src="require('@/assets/img/adress_icon.svg')" />
							</div>
							<span>
								This is a <b>Geo-funnel step</b>, you can use the same path/url for similar pages across all Geo-funnels within the same group.
								<b>Funnelish</b> will deliver the right step/page based on your visitors location.
							</span>
						</div>
					</div>
					<div class="brdr_content_wrpr">
						<h3 class="brdr_content_title">Step type</h3>
						<div class="wrap_select_step_type">
							<div class="row step-types-list" v-if="newStep">
								<SelectButton label="Checkout" :src="require('@/assets/img/Order-Form.svg')"
								              :value="1" v-model="newStep.type"/>
								<SelectButton label="Upsell" :src="require('@/assets/img/upsell-2.svg')"
								              :value="2" v-model="newStep.type"/>
								<SelectButton label="Thank you page" :src="require('@/assets/img/Thank You Page.svg')"
								              :value="3" v-model="newStep.type"/>
								<SelectButton label="Downsell" :src="require('@/assets/img/Downsell.svg')"
								              :value="4" v-model="newStep.type"/>
								<SelectButton label="Landing page" :src="require('@/assets/img/Optin Page.svg')"
								              :value="5" v-model="newStep.type"/>
								<SelectButton label="Other" :src="require('@/assets/img/Other.svg')"
								              :value="6" v-model="newStep.type"/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import API from "@/api"
import {mapGetters} from "vuex"
import stepTypes from "@/helpers/stepTypes"
import InputField from "@/components/base/input-field";
import VButton from "@/components/base/v-button";
import SelectButton from "@/components/base/select_button";
import Loading from "@/components/Loading";

export default {
	name: "StepsSettings",
	components: {
		Loading,
		SelectButton,
		VButton,
		InputField
	},
	mixins: [API],
	props: ['id', 'step'],
	data: function () {
		return {
			loading: false,
			saving: false,
			stepData: [],
			saveString: "",
			singleStep: {},
			newStep: {},
			stepTypes: stepTypes,
		};
	},
	computed: {
		notificationsOpen() {
			return this.$store.state.notificationsOpen;
		},
		...mapGetters([
			"getStepDataStore",
			"getSingleStepStore",
			"getFunnelStore"
		]),
		isGeoFunnel() {
			return this.getFunnelStore && this.getFunnelStore.is_sub_funnel;
		},
		userId() {
			return this.$store.state.user
		},
		getId() {
			return this.$route.params.id
		},
		getStepId() {
			return this.$route.params.step
		},
		stepPath() {
			if (!this.getFunnelStore.domain_name) return '/';
			let path = this.getFunnelStore.domain_name + '/';
			if (this.getFunnelStore.path) {
				path += this.getFunnelStore.path + '/';
			}
			return path;
		},
		getFunnelsPath() {
			var path = '/wfunnel/' + this.getId;
			if (this.getStepId) {
				path += '/steps/' + this.getStepId
			}
			return path
		},
	},
	// watch: {
	// 	step(val) {
	// 		this.init();
	// 	}
	// },
	methods: {
		stripUrl(ev, field) {
			var regex = /^(?:https?:\/\/)?(?:www\.)?/i;
			var url = ev.replace(regex, '');
			this.newStep[field] = url.trim();
		},
		selectType(type) {
			this.newStep['type'] = type;
		},
		async saveStep() {
			try {
				this.saving = true;

				let {id, step} = this.$route.params;
				this.newStep.url = [this.getFunnelStore.domain_name,
					this.getFunnelStore.path,
					this.newStep.path].filter(Boolean).join('/');

				let result = await this.api.wsteps.patch(id, this.newStep);

				if (!result.error) {
					this.$store.dispatch('EDIT_STEP', result);

					this.$store.dispatch('setSingleStepStore', this.newStep);
					this.$nextTick(() => this.$router.push({path: `/wfunnel/${id}/steps/${step}`}));
				} else {
					if (result.info) {
						this.$notify({
							group: 'main',
							title: result.info.data,
							type: 'warn',
						});
					} else
						throw result;
				}
			} catch (e) {
				console.log('ERROR', e);
				this.$notify({
					group: 'main',
					title: "Something went wrong! try again.",
					type: 'error',
				});
			} finally {
				this.saving = false;
			}
		},
		async loadStep(id, step) {
			try {
				this.loading = true;
				this.imageLoading = true;
				let res = (this.getSingleStepStore && parseInt(this.getSingleStepStore.funnel_id) === parseInt(id) && parseInt(this.getSingleStepStore.id) === parseInt(step)) ? this.getSingleStepStore : await this.api.wsteps.get(id, step);
				let saveStr = JSON.stringify(res);
				this.newStep = JSON.parse(saveStr);
			} catch (e) {
				this.$notify({
					type:"warn",
					group: "main",
					title: "Something went wrong... Please try again later",
				});
				console.error("error", e);
			} finally {
				this.loading = false;
				this.show = true;
			}
		},
		async init(id, step) {
			await this.loadStep(id, step);
		},
		closeSettings() {
			var {id, step} = this.$route.params;
			this.$router.push({path: `/wfunnel/${id}/steps/${step}`});
		}
	},
	mounted() {
	},
	created() {
		let {id, step} = this.$route.params;
		this.init(id, step);
	},
}
</script>

<style>
fieldset {
	border: 2px solid #E4E6F1;
	border-radius: 12px;
	height: 55px;
	margin-bottom: 30px;
	position: relative;
}

fieldset legend {
	font-weight: 500;
	font-size: 13px;
	line-height: 150%;
	letter-spacing: 0.02em;
	color: #C5C7D2;
}

fieldset input, fieldset .value {
	position: absolute;
	width: 100%;
	height: 100%;
	left: 0;
	top: 4px;
	background: transparent;
	border: none;
	padding: 0 15px;
	display: flex;
	align-items: center;
	font-size: 14px;
	letter-spacing: 0.02em;
	color: #636A7B;
}

.check .icon_check svg {
	max-width: 18px;
	max-height: 18px;
}

.check {
	display: flex;
	align-items: center;
	margin-left: 31px;
	font-weight: 500;
	font-size: 15px;
	letter-spacing: 0.02em;
	color: #4368E0;
}
</style>
